// File: frontend/src/services/modlogService.ts
// src/services/modlogService.ts

import { apiClient } from "./apiClient";
import { PageResponse } from "../models/PaginationModel";

// DTO for entries in the user's moderation log
export interface ModlogEntry {
  id: number;
  content: string;
  createdAt: string;          // ISO date-time string
  // Match target fields (null for non-match entries)
  matchId: number | null;
  homeTeam: string | null;
  awayTeam: string | null;
  matchDate: string | null;   // ISO date string (YYYY-MM-DD)
  // Club target fields (null for non-club entries)
  clubName: string | null;
  clubSlug: string | null;
  // Team target fields (null for non-team entries)
  teamName: string | null;
  teamClubSlug: string | null;
  teamSlug: string | null;
  teamCode: string | null;     // sub-team code for display (e.g. "u19", "1b")
  // Person target fields (null for non-person entries)
  personName: string | null;
  personSlug: string | null;
  // Custom topic ("gündem") target fields (null for non-topic entries)
  customTopicTitle: string | null;
  customTopicSlug: string | null;
  // Moderation action fields
  actionType: "DELETED" | "EDITED";
  actionAt: string;           // ISO date-time string
  actionByUsername: string;
  reason: string | null;
}

/**
 * Fetch a page of the current user's moderation log entries.
 * Includes entries deleted by admin/mod and entries edited by admin/mod.
 */
export const getModlogEntries = async (
  page: number,
  size: number
): Promise<PageResponse<ModlogEntry>> => {
  return apiClient.get<PageResponse<ModlogEntry>>(
    `/api/entries/modlog?page=${page}&size=${size}`
  );
};